import React from 'react';
import I18n from 'i18n-js';
import { tv } from 'tailwind-variants';
import useFlags from '@/hooks/useFlags';
import LibraryCard from '@/components/shared/NewLessonOverview/Libraries/LibraryCard';
import useLessonOverviewContext from '@/components/shared/NewLessonOverview/useLessonOverviewContext';
import Text from '@/components/ui/Text';
import librariesUtils from './Libraries.utils';

const librariesStyles = tv({
  base: 'tw-mb-[1.5rem] tw-bg-light-grey tw-flex-auto tw-basis-[25rem]',
  variants: {
    reflow: {
      false: 'tw-pl-[2rem] tw-min-w-[25rem]',
      true: 'tw-px-4 reflow-narrow:tw-px-8',
    },
  },
});

const Libraries = () => {
  const { accessibilityReflow } = useFlags();
  const lesson = useLessonOverviewContext(state => state.lesson);
  const unitId = useLessonOverviewContext(state => state.unitId);
  const civicsLibrary = useLessonOverviewContext(state => state.civicsLibrary);
  const primarySourceLibrary = useLessonOverviewContext(state => state.primarySourceLibrary);
  const programId = useLessonOverviewContext(state => state.programId);
  const libraries = librariesUtils({ civicsLibrary, lesson, primarySourceLibrary, programId, unitId });

  return (
    <div className={librariesStyles({ reflow: accessibilityReflow })}>
      <Text className="tw-mb-[2rem] tw-mt-[1.5rem]" tag="h2" variant="heading3">
        {I18n.t('looking_for_more')}
      </Text>
      <div className="tw-flex tw-flex-wrap tw-justify-start tw-gap-2">
        {libraries.map(libraryCard => (
          <LibraryCard
            key={libraryCard.title_tag}
            icon={libraryCard.icon}
            path={libraryCard.path}
            titleTag={libraryCard.title_tag}
          />
        ))}
      </div>
    </div>
  );
};

export default Libraries;
